// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1oRBU","footer":"ReportModalFilter_footer__yoBV1"};